import { render, staticRenderFns } from "./CommissionSettingsTabs.vue?vue&type=template&id=6c3ccf4a"
import script from "./CommissionSettingsTabs.vue?vue&type=script&lang=js"
export * from "./CommissionSettingsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports